import React, { useState, useEffect, useRef, useCallback } from 'react';

const API_BASE = 'http://174.138.79.56:3002';

// ─── CSS ──────────────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=Syne:wght@400;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg:      #080c14;
    --surface: #0f1623;
    --border:  #1a2535;
    --text:    #cbd5e1;
    --muted:   #475569;
    --accent:  #38bdf8;
    --gold:    #fbbf24;
    --mono:    'Space Mono', monospace;
    --display: 'Syne', sans-serif;
  }

  html, body, #root { height: 100%; background: var(--bg); color: var(--text); font-family: var(--mono); font-size: 12px; overflow: hidden; }

  .app { display: flex; flex-direction: column; height: 100vh; }

  /* Header */
  .header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 18px; height: 42px;
    background: var(--surface); border-bottom: 1px solid var(--border);
    flex-shrink: 0; z-index: 100;
  }
  .header-title { font-family: var(--display); font-size: 15px; font-weight: 800; color: var(--accent); letter-spacing: -0.3px; }
  .header-title span { color: var(--text); font-weight: 400; }
  .header-clock { font-family: var(--display); font-size: 18px; font-weight: 700; color: var(--gold); letter-spacing: 1px; }
  .header-right { display: flex; align-items: center; gap: 16px; font-size: 11px; color: var(--muted); }
  .stat { display: flex; flex-direction: column; align-items: flex-end; }
  .stat-val { color: var(--text); font-weight: 700; font-size: 13px; }

  /* Layout */
  .main { display: flex; flex: 1; overflow: hidden; }
  .map-wrap { flex: 1; position: relative; }
  #map { width: 100%; height: 100%; }

  /* Dark map tiles */
  .leaflet-tile-pane { filter: brightness(0.15) saturate(0.3) hue-rotate(200deg); }
  .leaflet-control-zoom a { background: var(--surface) !important; color: var(--text) !important; border-color: var(--border) !important; }

  /* Panel */
  .panel {
    width: 280px; flex-shrink: 0;
    display: flex; flex-direction: column;
    background: var(--surface); border-left: 1px solid var(--border);
    overflow: hidden;
  }
  .panel-block { padding: 12px 14px; border-bottom: 1px solid var(--border); }
  .block-label {
    font-size: 9px; font-weight: 700; letter-spacing: 0.14em;
    text-transform: uppercase; color: var(--muted); margin-bottom: 8px;
  }

  /* Filter grid */
  .fg { display: grid; grid-template-columns: 1fr 1fr; gap: 7px; }
  .fg.full { grid-template-columns: 1fr; }
  .field label { display: block; font-size: 9px; color: var(--muted); letter-spacing: 0.06em; text-transform: uppercase; margin-bottom: 3px; }
  .field select {
    width: 100%; padding: 5px 7px;
    background: var(--bg); border: 1px solid var(--border);
    border-radius: 3px; color: var(--text);
    font-family: var(--mono); font-size: 11px; outline: none; cursor: pointer;
  }
  .field select:focus { border-color: var(--accent); }

  /* Speed control */
  .speed-row { display: flex; gap: 5px; margin-top: 8px; }
  .speed-btn {
    flex: 1; padding: 5px 0; background: var(--bg);
    border: 1px solid var(--border); border-radius: 3px;
    color: var(--muted); font-family: var(--mono); font-size: 10px;
    cursor: pointer; transition: all 0.1s;
  }
  .speed-btn.active { background: var(--accent); border-color: var(--accent); color: var(--bg); font-weight: 700; }

  /* Play/pause */
  .play-row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
  .play-btn {
    width: 30px; height: 30px; border-radius: 50%;
    background: var(--accent); border: none; color: var(--bg);
    font-size: 11px; cursor: pointer; display: flex;
    align-items: center; justify-content: center; flex-shrink: 0;
    transition: transform 0.1s;
  }
  .play-btn:hover { transform: scale(1.1); }
  .time-range { font-size: 10px; color: var(--muted); }

  /* Route toggles */
  .route-list { display: flex; flex-direction: column; gap: 4px; }
  .route-item {
    display: flex; align-items: center; gap: 7px;
    padding: 5px 7px; border-radius: 3px; cursor: pointer;
    transition: background 0.1s; user-select: none;
  }
  .route-item:hover { background: var(--bg); }
  .route-item.off { opacity: 0.3; }
  .route-dot { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }
  .route-name { font-size: 10px; flex: 1; }
  .route-trips { font-size: 9px; color: var(--muted); }

  /* Active boats counter */
  .boats-badge {
    position: absolute; bottom: 14px; left: 14px;
    background: rgba(8,12,20,0.8); border: 1px solid var(--border);
    border-radius: 4px; padding: 7px 12px; z-index: 500;
    backdrop-filter: blur(6px); pointer-events: none;
  }
  .boats-num { font-family: var(--display); font-size: 22px; font-weight: 800; color: var(--accent); line-height: 1; }
  .boats-label { font-size: 9px; color: var(--muted); letter-spacing: 0.1em; text-transform: uppercase; margin-top: 2px; }

  /* Selected stop */
  .stop-detail { flex: 1; overflow-y: auto; padding: 12px 14px; }
  .stop-detail::-webkit-scrollbar { width: 3px; }
  .stop-detail::-webkit-scrollbar-thumb { background: var(--border); }
  .stop-name { font-family: var(--display); font-size: 13px; font-weight: 700; color: var(--text); margin-bottom: 3px; }
  .stop-route { font-size: 10px; margin-bottom: 12px; }
  .stat-row { display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid var(--border); font-size: 11px; }
  .stat-row:last-child { border-bottom: none; }
  .stat-lbl { color: var(--muted); }
  .stat-v { color: var(--gold); font-weight: 700; }
  .back-btn { background: none; border: none; color: var(--muted); font-family: var(--mono); font-size: 10px; cursor: pointer; margin-bottom: 10px; display: block; }
  .back-btn:hover { color: var(--text); }

  .empty { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: var(--muted); text-align: center; padding: 20px; gap: 6px; }
  .empty-icon { font-size: 26px; }
  .empty-title { font-family: var(--display); font-size: 12px; font-weight: 700; color: var(--text); }
`;

// ─── Helpers ──────────────────────────────────────────────────
function timeToSecs(t) {
  if (!t) return 0;
  const [h, m, s] = t.split(':').map(Number);
  return h * 3600 + m * 60 + (s || 0);
}

function secsToTime(s) {
  const h = Math.floor(s / 3600) % 24;
  const m = Math.floor((s % 3600) / 60);
  const ampm = h < 12 ? 'am' : 'pm';
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${h12}:${String(m).padStart(2, '0')}${ampm}`;
}

function lerp(a, b, t) { return a + (b - a) * t; }

// Distance between two lat/lon points (simple Euclidean, good enough for short distances)
function dist(a, b) {
  const dlat = a.lat - b.lat;
  const dlon = a.lon - b.lon;
  return Math.sqrt(dlat * dlat + dlon * dlon);
}

// Find the index of the shape point closest to a given stop
function findClosestShapeIdx(shapePoints, stopLat, stopLon) {
  let minDist = Infinity;
  let minIdx = 0;
  shapePoints.forEach((pt, i) => {
    const d = dist({ lat: pt.lat, lon: pt.lon }, { lat: stopLat, lon: stopLon });
    if (d < minDist) { minDist = d; minIdx = i; }
  });
  return minIdx;
}

// Given a trip with shape_points and stops, precompute shape segment indices per stop
// Returns array of shape indices, one per stop
function buildStopShapeIndices(shapePoints, stops) {
  if (!shapePoints || shapePoints.length === 0) return stops.map(() => 0);
  let searchFrom = 0;
  return stops.map(stop => {
    let minDist = Infinity;
    let minIdx = searchFrom;
    // Search forward from last found index to avoid backtracking
    for (let i = searchFrom; i < shapePoints.length; i++) {
      const d = dist({ lat: shapePoints[i].lat, lon: shapePoints[i].lon },
                     { lat: stop.stop_lat, lon: stop.stop_lon });
      if (d < minDist) { minDist = d; minIdx = i; }
      // Stop searching if we've moved far past the closest point
      if (d > minDist * 3 && i > minIdx + 5) break;
    }
    searchFrom = minIdx;
    return minIdx;
  });
}

// Interpolate position along shape points between two stop indices
// t=0 → at fromIdx, t=1 → at toIdx
function interpolateAlongShape(shapePoints, fromIdx, toIdx, t) {
  if (!shapePoints || shapePoints.length === 0) return null;
  if (fromIdx === toIdx) return { lat: shapePoints[fromIdx].lat, lon: shapePoints[fromIdx].lon };

  const segCount = Math.abs(toIdx - fromIdx);
  const step = toIdx > fromIdx ? 1 : -1;
  const targetFloat = fromIdx + t * segCount * step;
  const segIdx = Math.floor(Math.abs(targetFloat - fromIdx));
  const segT   = (Math.abs(targetFloat - fromIdx)) - segIdx;

  const idx1 = fromIdx + segIdx * step;
  const idx2 = Math.min(Math.max(idx1 + step, 0), shapePoints.length - 1);

  const p1 = shapePoints[Math.max(0, Math.min(idx1, shapePoints.length - 1))];
  const p2 = shapePoints[Math.max(0, Math.min(idx2, shapePoints.length - 1))];

  return {
    lat: lerp(p1.lat, p2.lat, segT),
    lon: lerp(p1.lon, p2.lon, segT),
  };
}

function hexToRgba(hex, alpha = 1) {
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

// Offset a polyline perpendicular to its direction
// offsetDeg is in degrees (~0.0003 deg ≈ 30m at NYC latitude)
function offsetPolyline(points, offsetDeg) {
  if (points.length < 2 || offsetDeg === 0) return points;
  return points.map((pt, i) => {
    const prev = points[Math.max(0, i - 1)];
    const next = points[Math.min(points.length - 1, i + 1)];
    // Direction vector
    const dlat = next[0] - prev[0];
    const dlon = next[1] - prev[1];
    const len  = Math.sqrt(dlat * dlat + dlon * dlon) || 1;
    // Perpendicular (rotate 90deg)
    const perpLat = -dlon / len;
    const perpLon =  dlat / len;
    return [pt[0] + perpLat * offsetDeg, pt[1] + perpLon * offsetDeg];
  });
}

// Offset amounts per route so overlapping routes are visually separated
const ROUTE_OFFSETS = {
  'AS': -0.0006,
  'ER':  0.0003,
  'GI':  0.0000,
  'RS': -0.0003,
  'RW':  0.0006,
  'SB': -0.0003,
  'SG':  0.0003,
  'SV':  0.0006,
};

// ─── App ──────────────────────────────────────────────────────
export default function App() {
  const mapRef       = useRef(null);
  const leafletRef   = useRef(null);
  const layerRef     = useRef(null);
  const routeLayerRef = useRef(null);
  const animRef      = useRef(null);
  const clockRef     = useRef(5 * 3600); // start at 5am
  const playingRef   = useRef(false);
  const speedRef     = useRef(120); // 120x realtime default
  const lastTickRef  = useRef(null);

  // Loaded data
  const tripsRef       = useRef([]);
  const ridByStopRef   = useRef({});
  const circlesRef     = useRef(new Map()); // trip_id -> {circle, labelMarker, passengers}

  const [filters, setFilters]       = useState({ year: 2023, month: 8, typeday: 'Weekday' });
  const [filterOptions, setFilterOptions] = useState({ years: [], months: [], routes: [], typedays: [] });
  const [activeRoutes, setActiveRoutes]   = useState(new Set());
  const [playing, setPlaying]       = useState(false);
  const [speed, setSpeed]           = useState(120);
  const [clockDisplay, setClockDisplay] = useState('5:00am');
  const [activeBoats, setActiveBoats]   = useState(0);
  const [selected, setSelected]     = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  // ── Init map ──
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = () => {
      const L = window.L;
      const map = L.map(mapRef.current, { zoomControl: false })
        .setView([40.72, -73.97], 11);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap', maxZoom: 18,
      }).addTo(map);
      L.control.zoom({ position: 'bottomright' }).addTo(map);
      routeLayerRef.current = L.layerGroup().addTo(map);
      layerRef.current      = L.layerGroup().addTo(map);
      leafletRef.current    = map;
    };
    document.head.appendChild(script);
    return () => { leafletRef.current?.remove(); };
  }, []);

  // ── Load filter options ──
  useEffect(() => {
    fetch(`${API_BASE}/api/filters`)
      .then(r => r.json())
      .then(data => {
        setFilterOptions(data);
        setActiveRoutes(new Set(data.routes.map(r => r.route_id)));
      });
  }, []);

  // ── Load data when filters change ──
  const loadData = useCallback(async () => {
    if (!leafletRef.current || !window.L) return;
    setDataLoaded(false);

    const { year, month, typeday } = filters;
    const serviceId = typeday === 'Weekday' ? 1 : 2;

    const [trips, shapes, ridership] = await Promise.all([
      fetch(`${API_BASE}/api/gtfs/trips?service_id=${serviceId}`).then(r => r.json()),
      fetch(`${API_BASE}/api/gtfs/shapes`).then(r => r.json()),
      fetch(`${API_BASE}/api/ridership/byStop?year=${year}&month=${month}&typeday=${typeday}`).then(r => r.json()),
    ]);

    tripsRef.current     = trips;
    ridByStopRef.current = ridership;

    // Draw route shapes
    const L = window.L;
    routeLayerRef.current.clearLayers();

    shapes.forEach(shape => {
      const rawPts = shape.points.map(p => [p.lat, p.lon]);
      if (rawPts.length < 2) return;
      const offset = ROUTE_OFFSETS[shape.route_id] || 0;
      const pts = offsetPolyline(rawPts, offset);
      L.polyline(pts, {
        color: `#${shape.route_color}`,
        weight: 2.5,
        opacity: 0.5,
      }).addTo(routeLayerRef.current);
    });

    // Clear existing boat circles
    circlesRef.current.forEach(({ circle }) => {
      layerRef.current.removeLayer(circle);
    });
    circlesRef.current.clear();

    setDataLoaded(true);
  }, [filters]);

  useEffect(() => {
    const timeout = setTimeout(loadData, 100);
    return () => clearTimeout(timeout);
  }, [loadData]);

  // ── Animation tick ──
  const tick = useCallback((timestamp) => {
    if (!playingRef.current) return;

    if (lastTickRef.current === null) lastTickRef.current = timestamp;
    const delta = (timestamp - lastTickRef.current) / 1000; // seconds elapsed
    lastTickRef.current = timestamp;

    clockRef.current += delta * speedRef.current;

    // Wrap at midnight (86400 seconds)
    if (clockRef.current >= 86400) clockRef.current = 5 * 3600;

    const now = clockRef.current;
    setClockDisplay(secsToTime(now));

    if (!leafletRef.current || !window.L || !layerRef.current) {
      animRef.current = requestAnimationFrame(tick);
      return;
    }

    const L = window.L;
    let boatCount = 0;

    tripsRef.current.forEach(trip => {
      if (!activeRoutes.has(trip.route_id)) return;
      const stops = trip.stops;
      if (!stops || stops.length < 2) return;

      const firstDep = timeToSecs(stops[0].departure_time);
      const lastArr  = timeToSecs(stops[stops.length - 1].arrival_time);

      // Is this trip active right now?
      if (now < firstDep || now > lastArr + 120) {
        if (circlesRef.current.has(trip.trip_id)) {
          const { circle } = circlesRef.current.get(trip.trip_id);
          layerRef.current.removeLayer(circle);
          circlesRef.current.delete(trip.trip_id);
        }
        return;
      }

      boatCount++;

      // Get or build shape indices for this trip
      if (!trip._shapeIndices) {
        trip._shapeIndices = buildStopShapeIndices(trip.shape_points || [], stops);
      }
      const shapeIndices = trip._shapeIndices;
      const shapePoints  = trip.shape_points || [];

      let pos = null;
      let passengers = 0;
      let currentStopIdx = 0;

      // Find which leg we're on
      for (let i = 0; i < stops.length - 1; i++) {
        const depTime = timeToSecs(stops[i].departure_time);
        const arrNext = timeToSecs(stops[i + 1].arrival_time);

        // Dwelling at stop i
        const arrThis = timeToSecs(stops[i].arrival_time);
        if (now >= arrThis && now <= depTime) {
          pos = shapePoints.length > 0
            ? { lat: shapePoints[shapeIndices[i]].lat, lon: shapePoints[shapeIndices[i]].lon }
            : { lat: stops[i].stop_lat, lon: stops[i].stop_lon };
          currentStopIdx = i;
          break;
        }

        // Travelling from stop i to stop i+1
        if (now >= depTime && now <= arrNext) {
          const t = (now - depTime) / (arrNext - depTime);
          if (shapePoints.length > 0) {
            pos = interpolateAlongShape(shapePoints, shapeIndices[i], shapeIndices[i + 1], t);
          } else {
            pos = { lat: lerp(stops[i].stop_lat, stops[i + 1].stop_lat, t),
                    lon: lerp(stops[i].stop_lon, stops[i + 1].stop_lon, t) };
          }
          currentStopIdx = i;
          break;
        }
      }

      // At final stop
      if (!pos) {
        const last = stops[stops.length - 1];
        pos = { lat: last.stop_lat, lon: last.stop_lon };
        currentStopIdx = stops.length - 1;
      }

      // Cumulative passengers up to current stop
      for (let i = 0; i <= currentStopIdx; i++) {
        const key = `${stops[i].stop_id}_${trip.route_id}`;
        const rid = ridByStopRef.current[key];
        if (rid) passengers += rid.avg_boardings;
      }

      // Scale radius
      const maxPass = 500;
      const radius = 4 + Math.sqrt(Math.min(passengers, maxPass) / maxPass) * 24;
      const color = `#${trip.route_color}`;

      if (!circlesRef.current.has(trip.trip_id)) {
        const circle = L.circleMarker([pos.lat, pos.lon], {
          radius,
          fillColor: color,
          color: color,
          weight: 1.5,
          fillOpacity: 0.85,
        }).addTo(layerRef.current);

        circle.on('click', () => {
          setSelected({ trip, stop: stops[currentStopIdx], passengers });
        });

        circle.bindTooltip(`
          <b>${trip.route_long_name}</b><br>
          Run ${trip.trip_short_name} → ${trip.trip_headsign}<br>
          ~${Math.round(passengers)} passengers
        `);

        circlesRef.current.set(trip.trip_id, { circle, passengers });
      } else {
        const { circle } = circlesRef.current.get(trip.trip_id);
        circle.setLatLng([pos.lat, pos.lon]);
        circle.setRadius(radius);
        circle.setStyle({ fillColor: color, color });
        circlesRef.current.get(trip.trip_id).passengers = passengers;
      }
    });

    setActiveBoats(boatCount);
    animRef.current = requestAnimationFrame(tick);
  }, [activeRoutes]);

  // ── Start/stop animation ──
  useEffect(() => {
    playingRef.current = playing;
    speedRef.current   = speed;
    if (playing) {
      lastTickRef.current = null;
      animRef.current = requestAnimationFrame(tick);
    } else {
      cancelAnimationFrame(animRef.current);
    }
    return () => cancelAnimationFrame(animRef.current);
  }, [playing, speed, tick]);

  const setFilter = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  const toggleRoute = (code) => {
    setActiveRoutes(prev => {
      const next = new Set(prev);
      if (next.has(code)) next.delete(code); else next.add(code);
      return next;
    });
  };

  return (
    <>
      <style>{css}</style>
      <div className="app">

        {/* Header */}
        <header className="header">
          <div className="header-title">NYC <span>Ferry</span> Ridership</div>
          <div className="header-clock">{clockDisplay}</div>
          <div className="header-right">
            <div className="stat">
              <span className="stat-val">{activeBoats}</span>
              <span>boats active</span>
            </div>
            <div className="stat">
              <span className="stat-val">{filterOptions.months.find(m => m.value === filters.month)?.label} {filters.year}</span>
              <span>{filters.typeday}</span>
            </div>
          </div>
        </header>

        <div className="main">

          {/* Map */}
          <div className="map-wrap">
            <div id="map" ref={mapRef} />
            <div className="boats-badge">
              <div className="boats-num">{activeBoats}</div>
              <div className="boats-label">boats on water</div>
            </div>
          </div>

          {/* Panel */}
          <aside className="panel">

            {/* Filters */}
            <div className="panel-block">
              <div className="block-label">Filter</div>
              <div className="fg">
                <div className="field">
                  <label>Year</label>
                  <select value={filters.year} onChange={e => setFilter('year', parseInt(e.target.value))}>
                    {filterOptions.years.map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>
                <div className="field">
                  <label>Month</label>
                  <select value={filters.month} onChange={e => setFilter('month', parseInt(e.target.value))}>
                    {filterOptions.months.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                  </select>
                </div>
                <div className="field fg full" style={{gridColumn:'1/-1'}}>
                  <label>Day Type</label>
                  <select value={filters.typeday} onChange={e => setFilter('typeday', e.target.value)}>
                    {filterOptions.typedays.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
              </div>

              {/* Playback */}
              <div className="play-row">
                <button className="play-btn" onClick={() => setPlaying(p => !p)}>
                  {playing ? '⏸' : '▶'}
                </button>
                <span className="time-range">5:00am → 11:59pm</span>
              </div>
              <div className="speed-row">
                {[30, 60, 120, 300, 600].map(s => (
                  <button
                    key={s}
                    className={`speed-btn ${speed === s ? 'active' : ''}`}
                    onClick={() => { setSpeed(s); speedRef.current = s; }}
                  >
                    {s}×
                  </button>
                ))}
              </div>
            </div>

            {/* Routes */}
            <div className="panel-block">
              <div className="block-label">Routes</div>
              <div className="route-list">
                {filterOptions.routes.map(r => {
                  const count = tripsRef.current.filter(t => t.route_id === r.route_id).length;
                  return (
                    <div
                      key={r.route_id}
                      className={`route-item ${activeRoutes.has(r.route_id) ? '' : 'off'}`}
                      onClick={() => toggleRoute(r.route_id)}
                    >
                      <div className="route-dot" style={{ background: `#${r.route_color}` }} />
                      <span className="route-name">{r.route_long_name}</span>
                      <span className="route-trips">{count} runs</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Stop detail or empty state */}
            {selected ? (
              <div className="stop-detail">
                <button className="back-btn" onClick={() => setSelected(null)}>← Back</button>
                <div className="stop-name">{selected.stop?.stop_name}</div>
                <div className="stop-route" style={{ color: `#${selected.trip.route_color}` }}>
                  ● {selected.trip.route_long_name} — Run {selected.trip.trip_short_name}
                </div>
                <div className="stat-row">
                  <span className="stat-lbl">Passengers on board</span>
                  <span className="stat-v">{Math.round(selected.passengers)}</span>
                </div>
                <div className="stat-row">
                  <span className="stat-lbl">Heading to</span>
                  <span className="stat-v">{selected.trip.trip_headsign}</span>
                </div>
                <div className="stat-row">
                  <span className="stat-lbl">Total stops</span>
                  <span className="stat-v">{selected.trip.stops?.length}</span>
                </div>
              </div>
            ) : (
              <div className="empty">
                <div className="empty-icon">🛥️</div>
                <div className="empty-title">
                  {dataLoaded ? 'Press ▶ to animate' : 'Loading...'}
                </div>
                <div style={{ fontSize: 10, color: 'var(--muted)', lineHeight: 1.6 }}>
                  {dataLoaded
                    ? 'Circles represent ferry boats. Size grows as passengers board at each stop.'
                    : 'Fetching schedule and ridership data...'}
                </div>
              </div>
            )}
          </aside>
        </div>
      </div>
    </>
  );
}
